import React from 'react';
import PropTypes from 'prop-types';
import settings from '../../config/settings';
import ModalOverlay from './ModalOverlay';
import {cardStyles} from '../const/VuCardConst';
import InlineFrame from './InlineFrame';
import urlJoin from 'url-join';
import qs from 'qs';
import autobind from 'autobind-decorator';


export default class PollContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      open: true
    };
  }

  open() {
    this.setState({open: true});
  }

  render() {
    return this.renderPoll();
  }

  @autobind
  renderPoll() {
    const {vucardStyle} = this.props;
    const {open} = this.state;

    if (open) {
      return (
        <ModalOverlay onClose={this.closePopup}>
          {
            <InlineFrame frameUrl={this.getVuCardFrameUrl()}
                         vucardStyle={vucardStyle}/>
          }
        </ModalOverlay>
      );
    }
    return null;
  }

  @autobind
  getVuCardFrameUrl() {
    const {record, cardId} = this.props;
    if (cardId) {
      return urlJoin(settings.cardFrameBaseURL, cardId, `?${qs.stringify(this.getVuCardFrameUrlQuery())}`);
    }
    return urlJoin(settings.recordFrameBaseURL, record.id);
  }

  getVuCardStandaloneUrl() {
    const {record, cardId} = this.props;
    if (cardId) {
      return urlJoin(settings.cardPageBaseURL, cardId, `?${qs.stringify(this.getVuCardStandaloneUrlQuery())}`);
    }
    return urlJoin(settings.recordPageBaseURL, record.id);
  }

  getVuCardFrameUrlQuery() {
    const {renderMode, rendererId, campaignId, collectionId, showsPageId} = this.props;
    const result = {
      rendererId,
      campaignId,
      collectionId,
      showsPageId,
      isPreloaded: 0,
      renderMode,
    };
    return result;
  }

  getVuCardStandaloneUrlQuery() {
    const {rendererId, campaignId, collectionId, showsPageId} = this.props;
    return {
      rendererId,
      campaignId,
      collectionId,
      showsPageId
    };
  }

  @autobind
  closePopup() {
    this.setState({open: false});
  }
}

PollContainer.displayName = 'PollContainer';
PollContainer.propTypes = {
  vucardStyle: PropTypes.string.isRequired,
  cardId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number]),
  campaignId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number]),
};

PollContainer.defaultProps = {
  vucardStyle: cardStyles.classic,
  onAfterTriggered: () => {
  }
};
